<template>
	<div>
		<div v-if="showModal">
			<teleport to="#fiche-modal">
				<!-- <transition name="modal"> -->
				<div class="modal-mask modal">
					<div
						class="modal-wrapper"
						@click="
							showModal = false;
							mainkeyword = '';
							graphrange = 'day';
						"
					>
						<div class="modal-dialog modal-lg">
							<div class="modal-content" @click.stop>
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0px">
										<h5 class="modal-title" id="dynvibeGraphDetailsTitleAuthors">
											{{ modalTitle }}
											<button
												type="button"
												class="close"
												@click="
													showModal = false;
													mainkeyword = '';
													graphrange = 'day';
													selectedTab = 'mostAssociatedBrands';
												"
											>
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body" id="modal-edit-body">
									<div v-if="type == 'trend'" class="col-lg-12">
										<div class="col-lg-6 col-xs-12">
											<div class="dynvibeBox" style="min-height: 100px; margin-bottom: 20px">
												<span
													style="
														font-size: 16px;
														font-weight: 700;
														color: rgb(239, 64, 46);
														text-transform: uppercase;
													"
													>Average Growth</span
												><br /><span class="dynvibeProfilesDetailsValue"
													>{{ avgGrowth >= 0 ? "+" + avgGrowth : avgGrowth }} %</span
												>
											</div>
										</div>
										<div class="col-lg-6 col-xs-12">
											<div class="dynvibeBox" style="min-height: 100px; margin-bottom: 20px">
												<span
													style="
														font-size: 16px;
														font-weight: 700;
														color: rgb(35, 5, 107);
														text-transform: uppercase;
													"
													>Period Growth</span
												><br /><span class="dynvibeProfilesDetailsValue">
													{{ periodGrowth >= 0 ? "+" + periodGrowth : periodGrowth }}
													%
													<img v-if="fire" style="width: 30px" class="flame-img" src="/img/flame.png" />
												</span>
											</div>
										</div>
									</div>
									<div class="col-lg-12" style="padding-top: 5px">
										<label class="labelRadio"
											>Daily
											<input
												type="radio"
												name="grouping"
												value="day"
												v-model="graphrange"
												:checked="graphrange === 'day'"
											/>
											<span class="checkmark"></span>
										</label>
										<label class="labelRadio"
											>Weekly
											<input
												type="radio"
												name="grouping"
												value="week"
												v-model="graphrange"
												:checked="graphrange === 'week'"
											/>
											<span class="checkmark"></span>
										</label>
										<label class="labelRadio"
											>Monthly
											<input
												type="radio"
												name="grouping"
												value="month"
												v-model="graphrange"
												:checked="graphrange === 'month'"
											/>
											<span class="checkmark"></span>
										</label>
										<dynvibestock
											v-if="mainkeyword"
											:incomingModal="true"
											:constructorType="'stockChart'"
											ref="stock"
											axios="storiesTopicLine"
											:type="'stockChart'"
											:typo="'search'"
											:value="mainkeyword + ' Trend Line'"
											:mainkeywordmixin="mainkeyword"
											:levelmixin="level"
											:trendfilters="trendfilters"
											:semanticfilters="semanticfilters"
											@zoomchart="changeZoomChart"
										></dynvibestock>
									</div>

									<div class="row" v-if="breadcrumb.length > 0">
										<div class="col-lg-10">
											<ol class="breadcrumb" v-if="breadcrumb.length > 0">
												<li
													v-for="(item, index) in breadcrumb"
													:key="index"
													:class="[
														'breadcrumb-item',
														{
															active: index === breadcrumb.length - 1,
														},
													]"
												>
													<a v-if="index !== breadcrumb.length - 1" href="#" @click="slice(index)">
														{{ item.key }} ({{ shortNames[item.type] }})
													</a>
													<span v-if="index === breadcrumb.length - 1">{{ item.key }}</span>
												</li>
											</ol>
										</div>
										<div class="col-lg-2">
											<button id="resetfilters" style="float: right" @click="resetFilters()">Reset filters</button>
										</div>
									</div>
									<div class="col-lg-12">
										<div class="dynvibeBox" style="min-height: 350px">
											<ul class="tabs-columns">
												<li
													v-bind:class="{ active: selectedTab === 'mostAssociatedBrands' }"
													@click="selectedTab = 'mostAssociatedBrands'"
												>
													<a href="#"> Brands</a>
												</li>
												<li
													v-bind:class="{ active: selectedTab === 'mostAssociatedTrends' }"
													@click="selectedTab = 'mostAssociatedTrends'"
												>
													<a href="#">Trends</a>
												</li>
												<li
													v-bind:class="{ active: selectedTab === 'mostAssociatedTopics' }"
													@click="selectedTab = 'mostAssociatedTopics'"
												>
													<a href="#">Topics</a>
												</li>
											</ul>
											<div style="float: left; padding-left: 20px; padding-bottom: 20px">
												<label class="labelCheckbox">
													Show trends evolution
													<input type="checkbox" name="displayHighchartsTrend" v-model="displayHighchartsTrend" />
													<span class="checkboxmark"></span>
												</label>
											</div>
											<div class="tabs-content">
												<dynvibecolumn
													:class="'tab-pane ' + (tab == 'Brands' ? 'active' : '')"
													ref="mostAssociated"
													:trendfilters="trendfilters"
													:semanticfilters="semanticfilters"
													:incomingModal="true"
													:axios="selectedTab"
													:clickable="true"
													:legend="true"
													:mainkeywordmixin="mainkeyword"
													:levelmixin="level"
													:title="selectedTab"
													:displayGrowth="displayHighchartsTrend"
												></dynvibecolumn>
											</div>
										</div>
									</div>
									<div
										class="row dynvibeRow col-lg-12"
										id="wordcloudBox"
										:class="postsExpanded == false ? 'col-lg-6' : 'col-lg-12'"
									>
										<dynvibewordcloud
											ref="wordcloudKeywords"
											title="Wordcloud"
											:incomingModal="true"
											axios="wordcloudKeywords"
											:mainkeyword="mainkeyword"
											:level="level"
											:editable="false"
											@wordcloudclicked="wordcloudclicked($event)"
										></dynvibewordcloud>
									</div>
									<div
										class="row dynvibeRow col-lg-12"
										id="postsBox"
										:class="postsExpanded == false ? 'col-lg-6' : 'col-lg-12'"
										:style="postsExpanded == false ? 'padding-right:0;' : ''"
									>
										<incomingposts
											ref="incomingposts"
											:trendfilters="trendfilters"
											:semanticfilters="semanticfilters"
											:mainkeyword="mainkeyword"
											:level="level"
											@expandposts="expandPosts($event)"
										></incomingposts>
									</div>
									<div class="row dynvibeRow col-lg-12" id="createBox">
										<div v-if="type === 'trend'" class="row col-lg-12">
											<createtrend ref="createtrend" :mastertag="mainkeyword"></createtrend>
										</div>
										<div v-else class="row col-lg-12">
											<createrules ref="createrules"></createrules>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<button class="btn-success dynvibeModalFooterBtn dynvibeModalFooterBtnApply" @click="save">
										Create
										{{ level == "mastertag" ? "trend" : "rules" }}
									</button>
									<button
										class="btn-danger dynvibeModalFooterBtn dynvibeModalFooterBtnClose"
										@click="
											showModal = false;
											mainkeyword = '';
											graphrange = 'day';
										"
									>
										Cancel
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </transition> -->
			</teleport>
		</div>
		<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
			<template v-slot:confirm-body>{{ confirmMessage }}</template>
		</confirm>
	</div>
</template>

<script>
import confirm from "@/components/globalVue/Confirm.vue";
import dynvibestock from "@/components/vueCharts/DynvibeStock.vue";
import dynvibewordcloud from "@/components/vueCharts/DynvibeWordCloud.vue";
import dynvibecolumn from "@/components/vueCharts/DynvibeColumn.vue";
//import dynvibecolumnstacked from "@/components/vueCharts/DynvibeColumnStacked.vue";
import createrules from "@/components/globalVue/createRules.vue";
import incomingposts from "@/components/incoming/IncomingPosts.vue";
import createtrend from "@/components/trend/modalCreate.vue";
import graphMixin from "@/mixins/graphMixin.js";

function flushQueue() {
	return new Promise((resolve) => setTimeout(resolve, 0));
}
export default {
	name: "createmastertag",
	mixins: [graphMixin],
	props: {
		type: {
			type: String,
			default: "",
		},
	},
	components: {
		confirm: confirm,
		dynvibestock: dynvibestock,
		dynvibewordcloud: dynvibewordcloud,
		dynvibecolumn: dynvibecolumn,
		//dynvibecolumnstacked: dynvibecolumnstacked,
		createrules: createrules,
		incomingposts: incomingposts,
		createtrend: createtrend,
	},
	emits: ["updatetrends"],
	data() {
		return {
			modalTitle: "",
			mainkeyword: "",
			showModal: false,
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			graphrange: "day",
			level: "",
			trendfilters: [],
			semanticfilters: [],
			modalkeywords: [],
			postsExpanded: false,
			periodGrowth: 0,
			avgGrowth: 0,
			fire: false,
			tab: "Brands",
			selectedTab: "mostAssociatedBrands",
			breadcrumb: [],
			shortNames: {
				mostAssociatedBrands: "Brand",
				mostAssociatedTopics: "Topic",
				mostAssociatedTrends: "Trend",
				wordcloudKeywords: "Wordcloud",
			},
			maxSizeBreadCrumb: 10,
			zoomChart: 1,
			displayHighchartsTrend: true,
		};
	},
	methods: {
		async reflow(ref) {
			await flushQueue();
			this.$refs[ref].$refs.basechart.reflow();
		},
		fillData(val, status = "") {
			if (status == "trendfilters") this.trendfilters = val;
			if (status == "semanticfilters") this.semanticfilters = val;

			if (status == "") {
				this.mainkeyword = val["mainkeyword"];
				this.level = val["level"];
				this.lang = val["lang"];
				this.avgGrowth = val["avgGrowth"];
				this.periodGrowth = val["periodGrowth"];
				this.fire = val["fire"];
				this.showModal = true;
				if (this.level == "mastertag") {
					this.modalTitle = 'Create a trend for "' + this.mainkeyword + '"';
				} else {
					this.modalTitle = 'Create a tag for "' + this.mainkeyword + '"';
				}
			}
		},
		save() {
			if (this.level == "mastertag") {
				this.saveTrend();
				this.$emit("updatetrends");
			} else {
				this.saveMastertag();
			}
		},
		saveTrend() {
			let params = {
				label: this.mainkeyword,
				mastertags: [this.mainkeyword],
			};
			this.$axios.post(this.$backendUrl + "trendAdd", this.$Qs.stringify(params)).then((response) => {
				if (response.data.isOk === 1) {
					this.confirmSuccessModal(this.mainkeyword + " has been created.");
				} else {
					this.confirmErrorModal(response.data.error);
				}
			});
		},
		saveMastertag() {
			if (!this.$refs.createrules.selectedMt || this.$refs.createrules.selectedMt === "") {
				this.confirmErrorModal("Mastertag empty");
				return;
			}

			let group1 = [];
			let group2 = [];
			let group1trimmed = this.$refs.createrules.group1.trim();
			let group2trimmed = this.$refs.createrules.group2.trim();
			if (group1trimmed != "") {
				this.confirmLoadingModal("open");
				group1.push(group1trimmed);
				group2.push(group2trimmed);

				let synonym1 = this.$refs.createrules.rowSynonym1;
				let synonym2 = this.$refs.createrules.rowSynonym2;
				let synonym1trimmed = synonym1.map((res) => res.trim());
				let synonym2trimmed = synonym2.map((res) => res.trim());
				let synonym1filtered = synonym1trimmed.filter(function (el) {
					return el != "";
				});
				let synonym2filtered = synonym2trimmed.filter(function (el) {
					return el != "";
				});

				group1 = group1.concat(synonym1filtered);
				group2 = group2.concat(synonym2filtered);

				//let newRule = [];
				let arrayRules = [];
				arrayRules.push(group1);
				arrayRules.push(group2);
				let rules = [];
				let rule = {
					rule: arrayRules,
					lang: this.$refs.createrules.selectedLanguage,
				};
				rules.push(rule);
				let mastertag = this.$refs.createrules.selectedMt;
				let createrules = this.$refs.createrules;

				let existingMastertag = this.$refs.createrules.existingMastertag;

				let data = {
					mastertag: mastertag,
					rules: rules,
					existingMastertag: existingMastertag,
					addByPost: true,
					twitteraccount: "",
					typemastertag: this.$refs.createrules.filterTagclass,
					subcategories: this.$refs.createrules.filterSubcategories,
				};

				if (mastertag != "") {
					this.$axios
						.post(this.$backendUrl + "updateMastertag", this.$Qs.stringify(data))
						.then((response) => {
							if (response.data.isOk) {
								this.confirmSuccessModal("Mastertag " + mastertag + " has been edited.");
								createrules.selectedMt = "";
								createrules.showModalRules = false;
								createrules.updateMastertags(response.data.mastertags);
								createrules.resetFields();
							}
						})
						.catch((error) => {
							console.log(error);
							this.confirmErrorModal("Mastertag " + mastertag + " has not been edited.");
						});
				} else {
					this.confirmErrorModal("Mastertag empty");
				}
			} else {
				this.confirmErrorModal("Group 1 empty");
			}
		},
		getDataGraph(event, axios) {
			if (this.breadcrumb.length >= this.maxSizeBreadCrumb) {
				this.confirmErrorModal("Size of the history is limited to " + this.maxSizeBreadCrumb);
				return;
			}
			let keyword = { key: event.point.category, type: axios };
			this.breadcrumb.push(keyword);
			this.refreshComponents();
		},
		expandPosts(e) {
			this.postsExpanded = e;
			let $this = this;
			setTimeout(function () {
				$this.$refs.wordcloudKeywords.updateWordcloud();
			}, 250);
		},
		resetFilters() {
			this.breadcrumb = [];
			this.refreshComponents();
		},
		wordcloudclicked(word) {
			if (this.breadcrumb.length >= this.maxSizeBreadCrumb) {
				this.confirmErrorModal("Size of the history is limited to " + this.maxSizeBreadCrumb);
				return;
			}
			let keyword = { key: word, type: "wordcloudKeywords" };
			this.breadcrumb.push(keyword);
			this.refreshComponents();
		},
		refreshComponents(columnGraphs = true, wordcloud = true, posts = true) {
			let parameters = { ...this.trendfilters, ...this.semanticfilters };
			parameters["modalkeywords"] = JSON.stringify(this.breadcrumb);

			if (columnGraphs) {
				//parameters["modallevel"] = this.level;
				this.modalkeywords = parameters["modalkeywords"];
				//parameters["modalcolumnIndex"] = event.point.series.columnIndex;
				//this.modalfilters.modalaxios = parameters["modalaxios"];
				//this.modalfilters.modallevel = parameters["modallevel"];
				if (this.selectedTab == "mostAssociatedBrands") {
					this.$refs.mostAssociated.setModalKeywords(parameters);
				}
				if (this.selectedTab == "mostAssociatedTrends") {
					this.$refs.mostAssociated.setModalKeywords(parameters);
				}
				if (this.selectedTab == "mostAssociatedTopics") {
					this.$refs.mostAssociated.setModalKeywords(parameters);
				}
			}

			if (wordcloud) {
				//parameters["modallevel"] = "keywords";
				this.$refs.wordcloudKeywords.loadComponent(parameters);
			}
			if (posts) {
				this.$refs.incomingposts.loadComponent(parameters);
			}
		},
		slice(index) {
			this.breadcrumb = this.breadcrumb.slice(0, index + 1);
			this.refreshComponents();
		},
		changeZoomChart(zoomChart) {
			this.zoomChart = zoomChart;
		},
	},
	watch: {
		graphrange(newVal) {
			let chartOptions = this.$refs.stock.$refs.basechart.getChartOptions();
			chartOptions.series[0].dataGrouping.units = [[newVal, [1]]];
			chartOptions.series[1].dataGrouping.units = [[newVal, [1]]];
			this.$refs.stock.changeZoom(this.zoomChart);
		},
		showModal() {
			this.breadcrumb = [];
			this.modalkeywords = [];
			if (this.showModal == false) {
				this.postsExpanded = false;
				//this.tab = "Brands";
			}
		},
	},
};
</script>

<style scoped>
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

.dynvibeButtonIcon {
	margin-left: 0;
}

@-moz-keyframes spin {
	100% {
		-moz-transform: rotate(360deg);
	}
}

@-webkit-keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

#wordcloudBox,
#postsBox,
#createBox {
	margin-left: 0px;
}
#createBox > div {
	padding-right: 0px;
	margin-right: 0px;
	margin-left: 0;
	padding-left: 0;
}

#resetfilters {
	float: right;
	color: red;
	border: 1px solid red;
	background-color: transparent;
	margin-top: 5px;
}

.modal-body {
	padding-bottom: 100px;
}

.modal-footer {
	position: absolute;
	bottom: 0;
	width: 100%;
	background-color: #fff;
}

ol.breadcrumb li {
	color: #33d1cd;
}

ol.breadcrumb li.active {
	color: #ccc;
}

ol.breadcrumb li > span {
	color: #ccc;
}

.labelRadio {
	display: inline;
	position: relative;
	padding-left: 20px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelRadio input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 1px;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #fff;
	border-radius: 50%;
	border: 1px solid #33d1cd;
}

/* On mouse-over, add a grey background color */
.labelRadio:hover input ~ .checkmark {
	background-color: rgba(51, 209, 205, 0.2);
}

/* When the checkbox is checked, add a blue background */
.labelRadio input:checked ~ .checkmark {
	background-color: #33d1cd;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.labelRadio input:checked ~ .checkmark:after {
	display: block;
}

.labelCheckbox {
	display: inline;
	position: relative;
	padding-left: 25px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelCheckbox input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkboxmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #eee;
}

.labelCheckbox:hover input ~ .checkboxmark {
	background-color: #eee;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	display: none;
}

.labelCheckbox input:checked ~ .checkboxmark:after {
	display: block;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	top: -2px;
	font-family: i;
	font-size: 11px;
	line-height: 20px;
}

.tabs-columns {
	border-bottom: none;
	list-style: none;
	padding-left: 0;
	margin-bottom: 60px;
}

.tabs-columns > li {
	position: relative;
	display: block;
	float: left;
	padding-top: 10px;
	padding-right: 15px;
	padding-bottom: 10px;
	padding-left: 15px;
	background-color: transparent;
	font-size: 16px;
	font-weight: 700;
	color: #cacaca;
	text-transform: uppercase;
}

.tabs-columns > li.active > a {
	color: #757575;
}

.tabs-columns > li:first-child a:before {
	content: "";
	display: block;
	position: absolute;
	left: 15px;
	bottom: 0;
	width: 20px;
	height: 4px;
	background-color: #757575;
	z-index: 0;
}

.tabs-content {
	margin-left: -25px;
	margin-right: -25px;
}
</style>
